import styled from "styled-components";

export const TransactionsSection = styled.div`
  height: 500px;
  max-height: 60vh;
  display: flex;
  flex-direction: column;

  & > div {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;
